<template>
  <span>Meeting Deleted successfully</span>
</template>

<script>
  export default {
    name: 'notification-template'
  }
</script>
